// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3_brh","col":"CardReaderDesc_col__20md3","label":"CardReaderDesc_label__Dr_ew"};